import { render, staticRenderFns } from "./askForLeaveLog.vue?vue&type=template&id=2fa8890d&"
import script from "./askForLeaveLog.vue?vue&type=script&lang=js&"
export * from "./askForLeaveLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports